import React from 'react';

export default function SecondBottomStaticRow({ data, borderClasses }) {
    return (
        <section className='flex flex-row gap-5 my-5'>
            <article className='flex flex-col gap-y-2 w-1/3'>
                <h1 className='w-full font-bold text-center'>Sales History</h1>
                <section className='w-full border overflow-auto max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr>
                                <th className='border-r-[1px] border-white pl-4'>Customer</th>
                                <th className={borderClasses}>CC</th>
                                <th className={borderClasses}>Price</th>
                                <th className='px-1'>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.sales?.map((data, index) => {
                                return (
                                    <tr key={index} className='border-b last:!border-none'>
                                        <td
                                            className={
                                                data?.highlighted
                                                    ? 'py-3 pl-4 border-4 border-green-600 rounded-md'
                                                    : 'py-3 pl-4'
                                            }
                                        >
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit')
                                                }
                                            >
                                                {data.customer}
                                            </h1>
                                        </td>
                                        <td className='px-1'>{data.conditionCode}</td>
                                        <td className='px-1'>
                                            {data.price?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </td>
                                        <td className='px-1'>{data.createdDate}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
            <article className='flex flex-col gap-y-2 w-1/3'>
                <h1 className='w-full font-bold text-center'>CCP</h1>
                <section className='w-full overflow-auto border max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr>
                                <th className='border-r-[1px] border-white pl-4'>Customer</th>
                                <th className={borderClasses}>CC</th>
                                <th className={borderClasses}>Price</th>
                                <th className={borderClasses}>BPrice</th>
                                <th className='px-1'>Date</th>
                                <th className='px-1'>Sale Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.ccp?.map((data, index) => {
                                return (
                                    <tr key={index} className='border-b last:!border-none'>
                                        <td className='py-3 pl-4'>
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit')
                                                }
                                            >
                                                {data.customer}
                                            </h1>
                                        </td>
                                        <td className='px-1'>{data.conditionCode}</td>
                                        <td className='px-1'>
                                            {data.price?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </td>
                                        <td className='px-1'>
                                            {data.bPrice?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </td>
                                        <td className='px-1'>{data.createdDate}</td>
                                        <td className='px-1'>{data.saleType}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
            <article className='flex flex-col gap-y-2 w-1/3'>
                <h1 className='w-full font-bold text-center'>Purchase History</h1>
                <section className='w-full overflow-auto border max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr className='text-center'>
                                <th className='border-r-[1px] border-white pl-4'>Customer</th>
                                <th className={borderClasses}>CC</th>
                                <th className={borderClasses}>Price</th>
                                <th className='px-1'>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.purchaseHistory?.map((data) => {
                                return (
                                    <tr className='border-b last:!border-none'>
                                        <td className='py-3 pl-4'>
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit')
                                                }
                                            >
                                                {data.vendorName}
                                            </h1>
                                        </td>
                                        <td className='px-1'>{data.conditionCode}</td>
                                        <td className='px-1'>
                                            {data.price?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </td>
                                        <td className='px-1'>{data.createdDate}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
        </section>
    );
}
